<template>
  <el-row>
    <el-col :span="6">
      <el-select
        v-model="formData.actionValue"
        value-key="value"
        filterable
        @change="changeAction"
        style="width: 100%"
      >
        <el-option
          v-for="action in actionOptions"
          :key="action.value"
          :label="action.label"
          :value="action"
        />
      </el-select>
    </el-col>
    <el-col :span="6">
      <el-select
        v-show="showLang"
        v-model="formData.langValue"
        value-key="langValue"
        filterable
        class="ml-2"
        style="width: 100%"
        @change="changeCallToAction"
      >
        <el-option
          v-for="lang in languages"
          :key="lang.keyword"
          :label="lang.langLabel"
          :value="lang"
        />
      </el-select>
    </el-col>
  </el-row>
</template>
<script>
import { callToActions } from '@/api/google/create';

export default {
  props: {
    type: {
      type: String,
      default: 'video',
    },
    value: {
      type: [Object, Array],
      default: () => {},
    },
  },

  data() {
    return {
      formData: { actionValue: {}, langValue: {} },
      actionOptions: [],
      actionLangMap: {},
    };
  },

  computed: {
    // 语种是否显示
    showLang() {
      if (!this.formData.actionValue?.value || this.type === 'video') {
        this.formData.lang = null;
        return false;
      }
      return true;
    },

    // 语种下拉
    languages() {
      return this.actionLangMap[this.formData.actionValue?.value] || [];
    },

    // 导出数据
    emitData() {
      const baseData = {
        action: this.formData.actionValue?.label,
        lang: this.formData.langValue?.langValue,
        keyword: this.formData.langValue?.keyword,
        key:
          this.type === 'img' && this.formData.actionValue?.label === '自动' ? null : this.formData.actionValue?.value,
      };

      return this.type === 'video' ? [baseData] : baseData;
    },
  },

  watch: {
    value: {
      handler() {
        this.initFormData();
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.getCallToAction();
  },

  methods: {
    initFormData() {
      const defaultData = {
        actionValue: { label: '自动', value: '' },
        langValue: {},
      };

      if (this.type === 'video') {
        const hasValidValue = this.value?.length && this.value[0]?.key;
        this.formData = hasValidValue
          ? {
              actionValue: {
                label: this.value[0].action,
                value: this.value[0].key,
              },
              langValue: {},
            }
          : defaultData;
      } else {
        const hasValidValue = this.value?.key;
        this.formData = hasValidValue
          ? {
              actionValue: {
                label: this.value.action,
                value: this.value.key,
              },
              langValue: {
                langValue: this.value.lang,
                keyword: this.value.keyword,
              },
            }
          : defaultData;
      }
    },

    changeAction(v) {
      if (!v.value) {
        this.formData.langValue = {};
      }
      this.changeCallToAction();
    },

    changeCallToAction() {
      this.$emit('input', this.emitData);
    },

    async getCallToAction() {
      try {
        const res = await callToActions({ adType: this.type });
        this.actionOptions = [
          { label: '自动', value: '' },
          ...res.data.actionOptions.filter((v) => v.adType == 'all' || v.adType == this.type),
        ];
        this.actionLangMap = res.data.actionLangMap;
      } catch (err) {
        this.actionOptions = [];
        this.actionLangMap = {};
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
